import React from 'react';
import { Link } from 'react-router-dom';

export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-white rounded-lg shadow-md p-8 text-center">
        <div className="text-6xl mb-4">❌</div>
        <h1 className="text-3xl font-bold mb-2">Payment Cancelled</h1>
        <p className="text-gray-600 mb-6">
          Your payment was not completed. You can try again or choose another method.
        </p>
        <Link to="/cart" className="inline-block bg-green-600 text-white px-4 py-2 rounded">Return to Cart</Link>
      </div>
    </div>
  );
}
